/**
* @type {PriceTypeCopy}
* @readonly
*/
export const PRICE_TYPE_COPY = {
  'lowest price of the season': 'Our Lowest Price of the Season',
  'deal of the day': 'Today Only',
};

export default PRICE_TYPE_COPY;
